/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MessageCaptureType {
    Diagnostic = 'Diagnostic',
    Search = 'Search',
    Price = 'Price',
    Booking = 'Booking',
    OrderCancel = 'OrderCancel',
    OrderUpdate = 'OrderUpdate',
    OrderRetrieve = 'OrderRetrieve',
    FareRules = 'FareRules',
    VirtualCard = 'VirtualCard',
    UpdatePrice = 'UpdatePrice',
    Ticket = 'Ticket'
}

export function MessageCaptureTypeFromJSON(json: any): MessageCaptureType {
    return MessageCaptureTypeFromJSONTyped(json, false);
}

export function MessageCaptureTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageCaptureType {
    return json as MessageCaptureType;
}

export function MessageCaptureTypeToJSON(value?: MessageCaptureType | null): any {
    return value as any;
}

